import React, {  useMemo, useState } from "react";
import { ComboBox, IComboBox, IComboBoxOption, IComboBoxStyles, IDropdownOption } from "@fluentui/react";
import { stringDefaultValue } from "../../../../../utils";
import { MultipleSelectorFilterStyle } from "./SelectorFilterStyle.jss";
import { useTheme } from "react-jss";

interface IMultipleSelectorFilterprops {
    selectedKey: string;
    onChange: (name: string, value: any) => any;
    options: IComboBoxOption[];
    label: string;
    isDisabled?: boolean;
    propertyName: string;
    isRequired?: boolean;
    multiSelect?: boolean;
    customFilteredOptions?:(filteredText:string) =>IDropdownOption[]
}

export const StringSelectorFilter: React.FC<IMultipleSelectorFilterprops> = ({
    label,
    onChange,
    options,
    selectedKey,
    isDisabled,
    propertyName,
    customFilteredOptions,
    multiSelect
}) => {
    const theme = useTheme();
    const style = MultipleSelectorFilterStyle({ theme });

    const comboBoxStyles: Partial<IComboBoxStyles> = {
        container: style.root,
        callout: style.callout,
        label: style.label,
        input: style.inputText,
        optionsContainer: style.optionsContainer,
    
    };

    const comboBoxRef = React.useRef<IComboBox>(null);
    const [filteredText, setFilteredText] = useState<string>("");

    const onOpenClick = React.useCallback(() => {
        comboBoxRef.current?.focus(true);
    }, []);

 

    const onOptionSelected = (option?: IDropdownOption) => {
        if (option) {
            onChange(propertyName, String(option.key));
        }
    };

    const onRenderItem = (option: any, defaultRender: any) => {
        return <div style={{ display: "flex", alignItems: "center" }}>{defaultRender(option)}</div>;
    };

    const onFilterOption = useMemo(() => {
        if (!filteredText) {
            return options;
        } else if (customFilteredOptions) {
            return customFilteredOptions(filteredText);
        }

        return options.filter((item) => {
            let filter = filteredText && item.text.toLocaleLowerCase().includes(filteredText.toLocaleLowerCase());
            return filter;
        });
    }, [filteredText, options, customFilteredOptions]);

    return (
        <div className={style.container}>
            <ComboBox
                componentRef={comboBoxRef}
                multiSelect={multiSelect}
                autoComplete="off"
                selectedKey={selectedKey}
                label={label}
                options={onFilterOption}
                onRenderItem={onRenderItem}
                onChange={(_: any, option: any) => {
                    onOptionSelected(option);
                }}
                allowFreeform={true}
                styles={comboBoxStyles}
                onInputValueChange={(value: any) => {
                    onOpenClick();
                    setFilteredText(value);
                }}
                onClick={() => {
                    onOpenClick();
                }}
                onMenuDismiss={() => {
                    setFilteredText("");
                }}
                disabled={isDisabled}
            />
        </div>
    );
};
